module.exports = __webpack_public_path__ + "static/media/3-Rakha-mobile.bdc6e6c3.webp";